import { pick } from 'lodash';
import { useCallback } from 'react';
import { appendSearchToRoute, useCurrentRouteSearch } from '../../../routes';
import { useSmartNavigate } from '../../../utils/useSmartNavigate';

type LoginRedirect = () => Promise<void>;

// A list of search params that should be preserved (passed through) during the redirect.
// These are preserved for marketing purposes and MRN routing.
const searchPassthrough = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'mrn'];

export const useLoginRedirect = (): LoginRedirect => {
  const navigate = useSmartNavigate();
  const searchParams = useCurrentRouteSearch();

  /**
   * Redirects the user after login to the post-login page.
   * The post-login page will handle access checks and final routing.
   * This approach leverages AppLayout's automatic access validation.
   */
  return useCallback(async (): Promise<void> => {
    // Gets a list of search parameters that should be preserved during the redirect.
    const toSearch = pick(searchParams, searchPassthrough);

    // Navigate to the post-login page, preserving MRN and other search params
    navigate(appendSearchToRoute('/post-login', toSearch), { replace: true });
  }, [navigate, searchParams]);
};
